module.exports = __webpack_public_path__ + "img/02.ef87798f.png";